import React, { useState } from 'react';
import { ChevronDown, Truck, RefreshCw, CreditCard, Package, Ruler, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQS = [
  { icon: Truck, q: 'How long does delivery take?', a: 'Every order is dispatched within 24-48 hours. Made in India, our domestic orders are delivered in just 6-7 days. International orders typically arrive within 7-12 business days.' },
  { icon: Truck, q: 'Do you charge for shipping?', a: 'No — shipping is completely free worldwide on every order, no minimum threshold. The cost is already priced into every product.' },
  { icon: RefreshCw, q: 'What is your returns and refunds policy?', a: 'We do not offer refunds or returns. However, we do offer size exchanges. The buyer is responsible for the one-way shipping cost of the exchange. See our Returns & Exchange page for full details.' },
  { icon: Ruler, q: 'How do I choose the right size?', a: 'Every product page has a "SIZE CHART" link right above the size selector. Our tees run oversized — if you prefer a snug fit, size down by one.' },
  { icon: CreditCard, q: 'What payment methods do you accept?', a: 'All major cards + PayPal. Your card is charged in the currency shown at checkout (INR or EUR).' },
  { icon: Package, q: 'Can I track my order?', a: 'Yes — head to our Track Order page and enter your order ID plus the email you used at checkout. You will see a live status timeline and courier tracking link once the order ships.' },
  { icon: Mail, q: 'How do I contact you?', a: 'Drop us a line via the Contact Us page or email feronstore@web.de — we usually respond within 24 hours.' },
];

const FAQs = () => {
  const [open, setOpen] = useState(0);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-14" data-testid="faqs-page">
        <section className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight">Frequently Asked Questions</h1>
          <div className="h-1 w-16 bg-[#22c55e] mx-auto mt-3" />
          <p className="text-gray-600 mt-4">Everything you need to know before you shop with Feron.</p>
        </section>

        <div className="space-y-3">
          {FAQS.map(({ icon: Ic, q, a }, i) => {
            const isOpen = open === i;
            return (
              <div key={q} className={`border rounded-xl overflow-hidden transition ${isOpen ? 'border-[#22c55e] shadow-sm' : 'border-gray-200'}`} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-neutral-50 transition"
                  data-testid={`faq-toggle-${i}`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[#22c55e]/10 border border-[#22c55e]/30 flex items-center justify-center text-[#22c55e] shrink-0">
                      <Ic size={18} />
                    </div>
                    <span className="font-black text-sm md:text-base">{q}</span>
                  </div>
                  <ChevronDown className={`transition-transform shrink-0 ${isOpen ? 'rotate-180 text-[#22c55e]' : 'text-gray-400'}`} size={18} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm text-gray-700 leading-relaxed" data-testid={`faq-answer-${i}`}>
                    {a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center bg-black text-white rounded-2xl p-8">
          <h3 className="font-black text-xl mb-2">Still have a question?</h3>
          <p className="text-white/70 mb-4 text-sm">Drop us a message — we usually reply within 24 hours.</p>
          <Link to="/contact-us" className="inline-block bg-[#22c55e] hover:bg-[#16a34a] text-black font-black px-6 py-3 rounded-full tracking-wider transition" data-testid="faq-contact-cta">
            CONTACT US
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FAQs;
